export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AccumulatePromotionPaypointResult = {
  __typename?: 'AccumulatePromotionPaypointResult';
  isSuccess: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  paypoint?: Maybe<PromotionPaypoint>;
};

export type AccumulateTravelClubPaypointResult = {
  __typename?: 'AccumulateTravelClubPaypointResult';
  isSuccess: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  paypoint?: Maybe<TravelClubPaypoint>;
};

export type ActiveCabinClass = {
  __typename?: 'ActiveCabinClass';
  C: Scalars['Boolean']['output'];
  F: Scalars['Boolean']['output'];
  P: Scalars['Boolean']['output'];
  Y: Scalars['Boolean']['output'];
};

export type ActivePassenger = {
  __typename?: 'ActivePassenger';
  adult: Scalars['Boolean']['output'];
  child: Scalars['Boolean']['output'];
  infant: Scalars['Boolean']['output'];
};

export type ActiveTripType = {
  __typename?: 'ActiveTripType';
  OW: Scalars['Boolean']['output'];
  RT: Scalars['Boolean']['output'];
};

export enum AddBookingStatus {
  Duplicate = 'DUPLICATE',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type AgreementStatus = {
  __typename?: 'AgreementStatus';
  agreeStatus: ConsentStatus;
};

export type Amenity = {
  __typename?: 'Amenity';
  equipmentDesc: Scalars['String']['output'];
  inFlightEntertainment?: Maybe<AmenityAvailability>;
  inFlightMealImages: Array<ImageFile>;
  insideImages: Array<ImageFile>;
  mealsAndBeverages?: Maybe<AmenityAvailability>;
  outsideImages: Array<ImageFile>;
  seatArrangement: Scalars['String']['output'];
  seatInfo: Scalars['String']['output'];
  usb?: Maybe<AmenityAvailability>;
  wiFi?: Maybe<AmenityAvailability>;
};

export enum AmenityAvailability {
  Chargeable = 'CHARGEABLE',
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

export enum BannerDomainType {
  Domestic = 'DOMESTIC',
  Overseas = 'OVERSEAS'
}

export enum BannerPosition {
  List = 'LIST',
  Main = 'MAIN',
  MainNotice = 'MAIN_NOTICE',
  Normal = 'NORMAL',
  Single = 'SINGLE'
}

export enum BannerTargetingType {
  Domain = 'DOMAIN',
  None = 'NONE'
}

export enum BannerType {
  Image = 'IMAGE',
  Text = 'TEXT'
}

export type Booking = {
  __typename?: 'Booking';
  agtBookingKey: Scalars['String']['output'];
  bookingDate: Scalars['DateTime']['output'];
  bookingKey: Scalars['String']['output'];
  bookingStatus: Scalars['String']['output'];
  confirmTotalFare: Scalars['Float']['output'];
  deleted: Scalars['Boolean']['output'];
  destinationImageUrl: Scalars['String']['output'];
  itinerary: Array<BookingItinerary>;
  landingUrlMo: Scalars['String']['output'];
  landingUrlPc: Scalars['String']['output'];
  otaId: Scalars['String']['output'];
  otaInfo: Ota;
  passengers: Passenger;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  pnrNo?: Maybe<Scalars['String']['output']>;
  promotionPaypoint?: Maybe<PromotionPaypoint>;
  seatClass: Scalars['String']['output'];
  tktDate?: Maybe<Scalars['DateTime']['output']>;
  travelClubPaypoint?: Maybe<TravelClubPaypoint>;
  tripType: Scalars['String']['output'];
};

export type BookingClassEdge = {
  __typename?: 'BookingClassEdge';
  node: Booking;
};

export type BookingConnection = {
  __typename?: 'BookingConnection';
  edges?: Maybe<Array<BookingClassEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookingItinerary = {
  __typename?: 'BookingItinerary';
  airlineCode: Scalars['String']['output'];
  airlineName: Scalars['String']['output'];
  arrivalAirportCode: Scalars['String']['output'];
  arrivalCityName: Scalars['String']['output'];
  arrivalDate?: Maybe<Scalars['String']['output']>;
  departureAirportCode: Scalars['String']['output'];
  departureCityName: Scalars['String']['output'];
  departureDate?: Maybe<Scalars['String']['output']>;
  journeyTime?: Maybe<Scalars['Int']['output']>;
  operatingCarrierName?: Maybe<Scalars['String']['output']>;
  stops?: Maybe<Scalars['Int']['output']>;
};

export type BookingOption = {
  __typename?: 'BookingOption';
  active: ServiceActive;
  adText?: Maybe<Scalars['String']['output']>;
  agreeStatus: Scalars['String']['output'];
  bookingUrl: Scalars['String']['output'];
  caution?: Maybe<Scalars['String']['output']>;
  csInfo?: Maybe<CsInfo>;
  expName: Scalars['String']['output'];
  fare: Scalars['Float']['output'];
  fareType: Scalars['String']['output'];
  hasPriceTransparency?: Maybe<Scalars['Boolean']['output']>;
  isCsCenter?: Maybe<Scalars['Boolean']['output']>;
  isCsCenterEmail?: Maybe<Scalars['Boolean']['output']>;
  isKoreanWebsite?: Maybe<Scalars['Boolean']['output']>;
  otaId: Scalars['ID']['output'];
  otaType?: Maybe<OtaType>;
  refundPolicy?: Maybe<RefundPolicy>;
  supportNPay?: Maybe<Scalars['Boolean']['output']>;
  supportNaverLogin: Scalars['Boolean']['output'];
};


export type BookingOptionActiveArgs = {
  device: DeviceType;
  searchType: SearchType;
};


export type BookingOptionRefundPolicyArgs = {
  searchType: SearchType;
};

export type BookingOptions = {
  __typename?: 'BookingOptions';
  combined: Array<BookingOption>;
  otaList: Array<BookingOption>;
};

export type BookingParamsInput = {
  aFuel: Scalars['Float']['input'];
  aTax: Scalars['Float']['input'];
  adultFare: Scalars['Float']['input'];
  airlineCode: Scalars['String']['input'];
  arrCity: Scalars['String']['input'];
  arrivalDateTime: Scalars['String']['input'];
  cFuel: Scalars['Float']['input'];
  cTax: Scalars['Float']['input'];
  childFare: Scalars['Float']['input'];
  depCity: Scalars['String']['input'];
  departureDateTime: Scalars['String']['input'];
  etc: Scalars['String']['input'];
  fitName: Scalars['String']['input'];
  iFuel?: Scalars['Float']['input'];
  iTax?: Scalars['Float']['input'];
  infantFare?: Scalars['Float']['input'];
  publishFee?: InputMaybe<Scalars['Float']['input']>;
  seatClass: Scalars['String']['input'];
  seatCnt?: InputMaybe<Scalars['Float']['input']>;
  stops?: Scalars['Float']['input'];
};

export type BookingRanking = {
  __typename?: 'BookingRanking';
  count: Scalars['Float']['output'];
  flightNumbers: Scalars['String']['output'];
  latestBookingDate: Scalars['DateTime']['output'];
  passengerType: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export enum BookingSortField {
  BookingDate = 'BOOKING_DATE',
  DepartureDate = 'DEPARTURE_DATE'
}

export type BookingSortOrderInput = {
  field: BookingSortField;
  order: SortOrder;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  onAirUrl?: Maybe<Scalars['String']['output']>;
};

export enum CabinClass {
  C = 'C',
  F = 'F',
  P = 'P',
  Y = 'Y',
  Yc = 'YC'
}

export type CityImage = {
  __typename?: 'CityImage';
  copyright?: Maybe<Scalars['String']['output']>;
  copyrightUrl?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
};

export type CodeName = {
  __typename?: 'CodeName';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ConsentStatus {
  Agreed = 'AGREED',
  Expired = 'EXPIRED',
  NotAgreed = 'NOT_AGREED',
  NotConfirmed = 'NOT_CONFIRMED',
  NotLoggedIn = 'NOT_LOGGED_IN'
}

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type Country = {
  __typename?: 'Country';
  countryName: Scalars['String']['output'];
};

export type CreatePriceChangesSubscriptionInput = {
  adultCount: Scalars['Float']['input'];
  cabinClass: CabinClass;
  changes: Array<Scalars['Int']['input']>;
  childCount: Scalars['Float']['input'];
  infantCount: Scalars['Float']['input'];
  isNonstop: Scalars['Boolean']['input'];
  itineraries: Array<PriceChangesSubscriptioItineraryInput>;
  minPrice: Scalars['Float']['input'];
  tripType: TripType;
};

export type CsInfo = {
  __typename?: 'CsInfo';
  active?: Maybe<Scalars['Boolean']['output']>;
  businessHour?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is365Days?: Maybe<Scalars['Boolean']['output']>;
  lunchTime?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['String']['output']>;
  otherContactInfo?: Maybe<Scalars['String']['output']>;
  phone1?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
};

export type DailyDomesticFare = {
  __typename?: 'DailyDomesticFare';
  date: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export enum DepartureTimeCategory {
  Day = 'DAY',
  Hour_0_3 = 'HOUR_0_3',
  Hour_3_6 = 'HOUR_3_6',
  Hour_6_9 = 'HOUR_6_9',
  Hour_9_12 = 'HOUR_9_12',
  Hour_12_15 = 'HOUR_12_15',
  Hour_15_18 = 'HOUR_15_18',
  Hour_18_21 = 'HOUR_18_21',
  Hour_21_24 = 'HOUR_21_24'
}

export type DeviceActive = {
  __typename?: 'DeviceActive';
  mobile: Scalars['Boolean']['output'];
  pc: Scalars['Boolean']['output'];
};

export type DeviceActiveBySearchType = {
  __typename?: 'DeviceActiveBySearchType';
  domestic: DeviceActive;
  international: DeviceActive;
};

export enum DeviceType {
  Mobile = 'MOBILE',
  Pc = 'PC'
}

export type EverywhereFlight = {
  __typename?: 'EverywhereFlight';
  departure: EverywhereFlightTrip;
  destination: EverywhereFlightTrip;
  duration: Scalars['Float']['output'];
  isOversea: Scalars['Boolean']['output'];
  stops?: Maybe<Scalars['Float']['output']>;
  totalFare: Scalars['Float']['output'];
};

export type EverywhereFlightTrip = {
  __typename?: 'EverywhereFlightTrip';
  airlineCode: Scalars['String']['output'];
  airlineName: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  cityImage?: Maybe<Scalars['String']['output']>;
  cityName: Scalars['String']['output'];
  continentId: Scalars['Float']['output'];
  countryCode: Scalars['String']['output'];
  fare?: Maybe<Scalars['Float']['output']>;
  location: Coordinate;
  rank: Scalars['Float']['output'];
  themeIds: Array<Scalars['Int']['output']>;
};

export type ExposeMeta = {
  __typename?: 'ExposeMeta';
  subject: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Fare = {
  __typename?: 'Fare';
  fare: Scalars['Float']['output'];
  stops: Scalars['Float']['output'];
};

export type FareType = {
  __typename?: 'FareType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  naverPaySaving?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type FaresByDate = {
  __typename?: 'FaresByDate';
  date: Scalars['String']['output'];
  fares: Array<Fare>;
};

export type Favorite = {
  __typename?: 'Favorite';
  bookingUrl: Scalars['String']['output'];
  cabinClass: Scalars['String']['output'];
  destinationImageUrl: Scalars['String']['output'];
  fare?: Maybe<Scalars['Int']['output']>;
  fareTypeName?: Maybe<Scalars['String']['output']>;
  flightId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  itineraries: Array<FavoriteItinerary>;
  passengers: Passenger;
  schedules: Array<FavoriteSchedule>;
  tripType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FavoriteConnection = {
  __typename?: 'FavoriteConnection';
  edges?: Maybe<Array<FavoriteEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FavoriteEdge = {
  __typename?: 'FavoriteEdge';
  node: Favorite;
};

export type FavoriteFlightDataInput = {
  fare: Scalars['Float']['input'];
  fareTp?: InputMaybe<Scalars['String']['input']>;
  itin: Array<FavoriteItineraryInput>;
  seatSt: Scalars['String']['input'];
  serviceUrl: Scalars['String']['input'];
};

export type FavoriteItinerary = {
  __typename?: 'FavoriteItinerary';
  arrivalCityName: Scalars['String']['output'];
  arrivalLocationCode: Scalars['String']['output'];
  departureCityName: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  departureLocationCode: Scalars['String']['output'];
};

export type FavoriteItineraryInput = {
  airlineCd: Scalars['String']['input'];
  airlineName: Scalars['String']['input'];
  arrAp: Scalars['String']['input'];
  arrDt: Scalars['String']['input'];
  arrTm: Scalars['String']['input'];
  dayCnt: Scalars['Float']['input'];
  depAp: Scalars['String']['input'];
  depDt: Scalars['String']['input'];
  depTm: Scalars['String']['input'];
  jrnyTm: Scalars['String']['input'];
  viaCnt: Scalars['Float']['input'];
};

export type FavoriteSchedule = {
  __typename?: 'FavoriteSchedule';
  airlineCode: Scalars['String']['output'];
  airlineName: Scalars['String']['output'];
  arrivalAirportCode: Scalars['String']['output'];
  arrivalDate: Scalars['String']['output'];
  departureAirportCode: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  stops: Scalars['Float']['output'];
};

export type FavoriteSearchParamsInput = {
  adultCnt: Scalars['Float']['input'];
  airports: Array<Scalars['String']['input']>;
  childCnt: Scalars['Float']['input'];
  cities: Array<Scalars['String']['input']>;
  fareTp: Scalars['String']['input'];
  infantCnt: Scalars['Float']['input'];
  sdates: Array<Scalars['String']['input']>;
  ticketTp: Scalars['String']['input'];
  tripTp: Scalars['String']['input'];
};

export enum FavoriteSortField {
  DepartureDate = 'DEPARTURE_DATE',
  UpdateDate = 'UPDATE_DATE'
}

export type FavoriteSortOrderInput = {
  field: FavoriteSortField;
  order: SortOrder;
};

export type GetBookingOptionsInput = {
  combinedFares?: InputMaybe<Array<OtaFareInput>>;
  curations?: InputMaybe<Array<Scalars['String']['input']>>;
  device: DeviceType;
  otaFares: Array<OtaFareInput>;
  scheduleIds: Array<Scalars['String']['input']>;
  searchParams: SearchParamsInput;
  searchType: SearchType;
};

export type GetDomesticFaresInput = {
  arrivalCityCode: Scalars['String']['input'];
  departureCityCode: Scalars['String']['input'];
  searchDateList: Array<Scalars['String']['input']>;
  timeCategoryList: Array<DepartureTimeCategory>;
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lunarDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: HolidayType;
};

export enum HolidayType {
  Consecutive = 'CONSECUTIVE',
  Etc = 'ETC',
  Holiday = 'HOLIDAY',
  National = 'NATIONAL',
  SolarTerms = 'SOLAR_TERMS',
  SpecialHoliday = 'SPECIAL_HOLIDAY'
}

export enum HotelImpSection {
  FlightDetail = 'FLIGHT_DETAIL',
  FlightDetail2 = 'FLIGHT_DETAIL2'
}

export type HotelInfo = {
  __typename?: 'HotelInfo';
  clkLogUrl: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overallRating: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  taAwards: Array<TaAward>;
  wkPlaceName: Scalars['String']['output'];
};

export enum HotelRecoType {
  Cvr = 'CVR',
  TopClk = 'TOP_CLK'
}

export type ImageFile = {
  __typename?: 'ImageFile';
  imageFileName: Scalars['String']['output'];
};

export type ImpRanking = {
  __typename?: 'ImpRanking';
  count: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  flightNumbers: Scalars['String']['output'];
  latestImpDate: Scalars['DateTime']['output'];
  route: Scalars['String']['output'];
};

export type ItineraryClass = {
  __typename?: 'ItineraryClass';
  arrivalLocationCode: Scalars['String']['output'];
  arrivalLocationName: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  departureLocationCode: Scalars['String']['output'];
  departureLocationName: Scalars['String']['output'];
};

export type ItineraryInput = {
  arrivalAirport: Scalars['String']['input'];
  departureAirport: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
};

export type ItineraryMongooseClass = {
  __typename?: 'ItineraryMongooseClass';
  arrivalLocationCode: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  departureLocationCode: Scalars['String']['output'];
};

export type LatestFareBySchedule = {
  __typename?: 'LatestFareBySchedule';
  airline: Scalars['String']['output'];
  airlineName: Scalars['String']['output'];
  arrivalAirportCode: Scalars['String']['output'];
  arrivalAirportName: Scalars['String']['output'];
  departureAirportCode: Scalars['String']['output'];
  departureAirportName: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  roundTripTime: Scalars['Float']['output'];
  sdate1: Scalars['String']['output'];
  sdate2: Scalars['String']['output'];
  stops: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  airportName?: Maybe<Scalars['String']['output']>;
  airportNameEn?: Maybe<Scalars['String']['output']>;
  cityImage?: Maybe<CityImage>;
  cityName?: Maybe<Scalars['String']['output']>;
  cityNameEn?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryNameEn?: Maybe<Scalars['String']['output']>;
  event: Scalars['Boolean']['output'];
  iataCode: Scalars['String']['output'];
  isDomestic: Scalars['Boolean']['output'];
  location?: Maybe<Coordinate>;
  popularity?: Maybe<Scalars['Float']['output']>;
};

export type MajorAirportsByRegion = {
  __typename?: 'MajorAirportsByRegion';
  airports: Array<Location>;
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MinFareByTheme = {
  __typename?: 'MinFareByTheme';
  departureDate: Scalars['String']['output'];
  fare: Scalars['Float']['output'];
  themeId: Scalars['Float']['output'];
  themeImage: Scalars['String']['output'];
  themeName: Scalars['String']['output'];
  themeOrder: Scalars['Float']['output'];
};

export type MinFareByType = {
  __typename?: 'MinFareByType';
  code: Scalars['String']['output'];
  fare: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  naverFare?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accumulatePromotionPaypoint: AccumulatePromotionPaypointResult;
  accumulateTravelclubPaypoint: AccumulateTravelClubPaypointResult;
  addBooking: AddBookingStatus;
  addFavorite: Scalars['Boolean']['output'];
  addFavoriteV2: Favorite;
  addHistory?: Maybe<SearchHistory>;
  createPriceChangesSubscription?: Maybe<PriceChangesSubscription>;
  deleteAllInactiveBookings: Scalars['Boolean']['output'];
  deleteBooking?: Maybe<Booking>;
  deleteFavorites: Array<Favorite>;
  deleteHistory: Scalars['Boolean']['output'];
  deletePriceChangesSubscription?: Maybe<PriceChangesSubscription>;
  logSelectedFlights: Scalars['Boolean']['output'];
  saveBookingAgreement: Scalars['String']['output'];
  updateFavoriteFlightPrice: UpdateFavoriteFlightPriceResult;
  updateNlabelAgreements: UpdateTravelPersonalInfoAgreementResponse;
  updatePriceAlertNightConsent: PriceAlertNightConsent;
  updatePriceChangesSubscription?: Maybe<PriceChangesSubscription>;
  updateReceiveAds: UpdateReceiveAdsResponse;
};


export type MutationAccumulatePromotionPaypointArgs = {
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
};


export type MutationAccumulateTravelclubPaypointArgs = {
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
};


export type MutationAddBookingArgs = {
  agtBookingKey: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
};


export type MutationAddFavoriteArgs = {
  flightData: FavoriteFlightDataInput;
  groupParam: FavoriteSearchParamsInput;
};


export type MutationAddFavoriteV2Args = {
  flightData: FavoriteFlightDataInput;
  groupParam: FavoriteSearchParamsInput;
};


export type MutationAddHistoryArgs = {
  history: SearchHistoryInput;
};


export type MutationCreatePriceChangesSubscriptionArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  subscription: CreatePriceChangesSubscriptionInput;
};


export type MutationDeleteBookingArgs = {
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
};


export type MutationDeleteFavoritesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteHistoryArgs = {
  hashKey: Scalars['String']['input'];
};


export type MutationDeletePriceChangesSubscriptionArgs = {
  searchKey: Scalars['String']['input'];
};


export type MutationLogSelectedFlightsArgs = {
  flights: Array<SelectedDomesticFlightInput>;
};


export type MutationUpdateFavoriteFlightPriceArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateNlabelAgreementsArgs = {
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
  isAgreed: Scalars['Boolean']['input'];
};


export type MutationUpdatePriceAlertNightConsentArgs = {
  isConsented: Scalars['Boolean']['input'];
};


export type MutationUpdatePriceChangesSubscriptionArgs = {
  subscription: UpdatePriceChangesSubscriptionInput;
};


export type MutationUpdateReceiveAdsArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  updateAssent: Scalars['Boolean']['input'];
};

export type Ota = {
  __typename?: 'Ota';
  active: ServiceActive;
  adText?: Maybe<Scalars['String']['output']>;
  caution?: Maybe<Scalars['String']['output']>;
  csInfo?: Maybe<CsInfo>;
  expName: Scalars['String']['output'];
  hasPriceTransparency?: Maybe<Scalars['Boolean']['output']>;
  isCsCenter?: Maybe<Scalars['Boolean']['output']>;
  isCsCenterEmail?: Maybe<Scalars['Boolean']['output']>;
  isKoreanWebsite?: Maybe<Scalars['Boolean']['output']>;
  otaId: Scalars['ID']['output'];
  otaType?: Maybe<OtaType>;
  refundPolicy?: Maybe<RefundPolicy>;
  supportNaverLogin: Scalars['Boolean']['output'];
};


export type OtaActiveArgs = {
  device: DeviceType;
  searchType: SearchType;
};


export type OtaRefundPolicyArgs = {
  searchType: SearchType;
};

export type OtaFareInput = {
  bookingParams: Array<BookingParamsInput>;
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
  fare: Scalars['Float']['input'];
  fareType: Scalars['String']['input'];
  origFare?: InputMaybe<Scalars['Float']['input']>;
  otaId: Scalars['String']['input'];
  supportNPay?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OtaType {
  GlobalAirline = 'GLOBAL_AIRLINE',
  GlobalOta = 'GLOBAL_OTA',
  KrAirline = 'KR_AIRLINE',
  KrOta = 'KR_OTA'
}

/** 페이지 정보 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** 페이지 데이타에서 해당 값의 개수만 제공 */
  first: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  /** 페이지 데이타 중 해당 값의 개수를 생략 */
  skip: Scalars['Int']['output'];
};

export type Passenger = {
  __typename?: 'Passenger';
  adult: Scalars['Float']['output'];
  child: Scalars['Float']['output'];
  infant: Scalars['Float']['output'];
};

export type PassengerInput = {
  adult: Scalars['Float']['input'];
  child: Scalars['Float']['input'];
  infant: Scalars['Float']['input'];
};

export type PriceAlertNightConsent = {
  __typename?: 'PriceAlertNightConsent';
  isConsented: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PriceChangesSubscriptioItineraryInput = {
  arrivalLocationCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  departureLocationCode: Scalars['String']['input'];
};

export type PriceChangesSubscription = {
  __typename?: 'PriceChangesSubscription';
  adultCount: Scalars['Float']['output'];
  cabinClass: CabinClass;
  changes: Scalars['JSON']['output'];
  childCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  departureDate: Scalars['DateTime']['output'];
  infantCount: Scalars['Float']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isNonstop: Scalars['Boolean']['output'];
  itineraries: Array<ItineraryClass>;
  originalMinPrice: Scalars['Float']['output'];
  searchKey: Scalars['String']['output'];
  tripType: TripType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedMinPrice?: Maybe<Scalars['Float']['output']>;
};

export type PriceChangesSubscriptionClassEdge = {
  __typename?: 'PriceChangesSubscriptionClassEdge';
  node: PriceChangesSubscription;
};

export type PriceChangesSubscriptionConnection = {
  __typename?: 'PriceChangesSubscriptionConnection';
  edges?: Maybe<Array<PriceChangesSubscriptionClassEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceGraph = {
  __typename?: 'PriceGraph';
  averageLowestFare: Scalars['Float']['output'];
  averageReservationFare?: Maybe<Scalars['Float']['output']>;
  fares: Array<PriceGraphFareBySearchKey>;
};

export type PriceGraphDetail = {
  __typename?: 'PriceGraphDetail';
  averageLowestFare: Scalars['Float']['output'];
  averageReservationFare?: Maybe<Scalars['Float']['output']>;
  fares: Array<PriceGraphFareByItineraryId>;
};

export type PriceGraphFareByItineraryId = {
  __typename?: 'PriceGraphFareByItineraryId';
  cabinClass?: Maybe<Scalars['String']['output']>;
  eventFareType?: Maybe<Scalars['String']['output']>;
  itineraryId?: Maybe<Scalars['String']['output']>;
  lowestFare?: Maybe<Scalars['Float']['output']>;
  reservationFare?: Maybe<Scalars['Float']['output']>;
  searchDate: Scalars['String']['output'];
};

export type PriceGraphFareBySearchKey = {
  __typename?: 'PriceGraphFareBySearchKey';
  eventFareType?: Maybe<Scalars['String']['output']>;
  isNonstop?: Maybe<Scalars['Boolean']['output']>;
  lowestFare?: Maybe<Scalars['Float']['output']>;
  reservationFare?: Maybe<Scalars['Float']['output']>;
  searchDate: Scalars['String']['output'];
  searchKey?: Maybe<Scalars['String']['output']>;
};

export type PriceTransparency = {
  __typename?: 'PriceTransparency';
  detail: Array<PriceTransparencyDetail>;
  tag: PriceTransparencyTag;
};

export type PriceTransparencyAdditionalServices = {
  __typename?: 'PriceTransparencyAdditionalServices';
  mealIncluded?: Maybe<Scalars['Boolean']['output']>;
  seatSelectionAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type PriceTransparencyBaggage = {
  __typename?: 'PriceTransparencyBaggage';
  available: Scalars['Boolean']['output'];
  conditions?: Maybe<Array<PriceTransparencyBaggageCondition>>;
};

export type PriceTransparencyBaggageCondition = {
  __typename?: 'PriceTransparencyBaggageCondition';
  quantity?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type PriceTransparencyCabin = {
  __typename?: 'PriceTransparencyCabin';
  available: Scalars['Boolean']['output'];
  identified: Scalars['Boolean']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PriceTransparencyCancel = {
  __typename?: 'PriceTransparencyCancel';
  available: Scalars['Boolean']['output'];
  conditions?: Maybe<Array<PriceTransparencyCancelCondition>>;
};

export type PriceTransparencyCancelCondition = {
  __typename?: 'PriceTransparencyCancelCondition';
  currency: Scalars['String']['output'];
  fee: Scalars['Int']['output'];
  period: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type PriceTransparencyChange = {
  __typename?: 'PriceTransparencyChange';
  available: Scalars['Boolean']['output'];
  conditions?: Maybe<Array<PriceTransparencyChangeCondition>>;
};

export type PriceTransparencyChangeCondition = {
  __typename?: 'PriceTransparencyChangeCondition';
  currency: Scalars['String']['output'];
  fee: Scalars['Int']['output'];
  period: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type PriceTransparencyChecked = {
  __typename?: 'PriceTransparencyChecked';
  available: Scalars['Boolean']['output'];
  identified: Scalars['Boolean']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type PriceTransparencyDetail = {
  __typename?: 'PriceTransparencyDetail';
  id: Scalars['String']['output'];
  otaId: Scalars['String']['output'];
  policy: PriceTransparencyPolicy;
};

export type PriceTransparencyMileage = {
  __typename?: 'PriceTransparencyMileage';
  amount?: Maybe<Scalars['Int']['output']>;
  available: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
};

export type PriceTransparencyPolicy = {
  __typename?: 'PriceTransparencyPolicy';
  additionalServices?: Maybe<PriceTransparencyAdditionalServices>;
  baggage?: Maybe<PriceTransparencyBaggage>;
  cancel?: Maybe<PriceTransparencyCancel>;
  change?: Maybe<PriceTransparencyChange>;
  mileage?: Maybe<PriceTransparencyMileage>;
};

export type PriceTransparencyTag = {
  __typename?: 'PriceTransparencyTag';
  cabin?: Maybe<PriceTransparencyCabin>;
  cancel?: Maybe<PriceTransparencyTagCancel>;
  change?: Maybe<PriceTransparencyTagChange>;
  checked?: Maybe<PriceTransparencyChecked>;
  isMileageAvailable?: Maybe<Scalars['Boolean']['output']>;
  isSeatSelectionAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type PriceTransparencyTagCancel = {
  __typename?: 'PriceTransparencyTagCancel';
  available: Scalars['Boolean']['output'];
  cancelFeePeriod?: Maybe<Scalars['DateTime']['output']>;
  identified: Scalars['Boolean']['output'];
  isFeeNeeded: Scalars['Boolean']['output'];
};

export type PriceTransparencyTagChange = {
  __typename?: 'PriceTransparencyTagChange';
  available: Scalars['Boolean']['output'];
  changeFeePeriod?: Maybe<Scalars['DateTime']['output']>;
  identified: Scalars['Boolean']['output'];
  isFeeNeeded: Scalars['Boolean']['output'];
};

export type Promotion = {
  __typename?: 'Promotion';
  active: Scalars['Boolean']['output'];
  airlines?: Maybe<Array<Scalars['String']['output']>>;
  benefit: PromotionBenefit;
  bookingEndDate?: Maybe<Scalars['DateTime']['output']>;
  bookingStartDate?: Maybe<Scalars['DateTime']['output']>;
  cabinClasses: ActiveCabinClass;
  departureEndDate?: Maybe<Scalars['DateTime']['output']>;
  departureStartDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destinationAirports?: Maybe<Array<Scalars['String']['output']>>;
  fareTypes?: Maybe<Array<CodeName>>;
  nonstopOnly: Scalars['Boolean']['output'];
  originAirports?: Maybe<Array<Scalars['String']['output']>>;
  otas?: Maybe<Array<Scalars['String']['output']>>;
  passengers: ActivePassenger;
  paymentMethods?: Maybe<Array<CodeName>>;
  route: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tripTypes: ActiveTripType;
};

export type PromotionBenefit = {
  __typename?: 'PromotionBenefit';
  limit?: Maybe<Scalars['Float']['output']>;
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type PromotionBenefitValueArgs = {
  fareType?: InputMaybe<CabinClass>;
  route: SearchType;
  trip?: InputMaybe<TripType>;
};

export type PromotionPaypoint = {
  __typename?: 'PromotionPaypoint';
  agtCode: Scalars['String']['output'];
  bookingKey: Scalars['String']['output'];
  isPaid: Scalars['Boolean']['output'];
  savingAmount: Scalars['Float']['output'];
  savingPossibleDate: Scalars['DateTime']['output'];
};

export type PromotionTextBanner = {
  __typename?: 'PromotionTextBanner';
  discount?: Maybe<PromotionBenefit>;
  payPoint?: Maybe<PromotionBenefit>;
};

export type Query = {
  __typename?: 'Query';
  airportAutocomplete: Array<SearchLocation>;
  airportDetailList: Array<Location>;
  bookingAgreement?: Maybe<Scalars['String']['output']>;
  bookingOptions: BookingOptions;
  bookingPartners: Array<Ota>;
  bookingRankings: Array<BookingRanking>;
  bookings: BookingConnection;
  country?: Maybe<Country>;
  coupons: Array<TravelCoupon>;
  domesticDailyPriceList: Array<DailyDomesticFare>;
  extraContent: Array<Amenity>;
  favorite: Favorite;
  favorites: FavoriteConnection;
  flightFare: Array<FaresByDate>;
  flightsCards: Array<FareType>;
  getNLabelAgreement: AgreementStatus;
  holidays: Array<Holiday>;
  impRankings: Array<ImpRanking>;
  isBiztripUser: Scalars['Boolean']['output'];
  majorAirportsByRegion: Array<MajorAirportsByRegion>;
  maskedId: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  onAirShoppingLive?: Maybe<Broadcast>;
  otaInfo: Ota;
  priceAlertNightConsent?: Maybe<PriceAlertNightConsent>;
  priceChangesSubscription?: Maybe<PriceChangesSubscription>;
  priceChangesSubscriptions: PriceChangesSubscriptionConnection;
  priceGraph?: Maybe<PriceGraph>;
  priceGraphDetail?: Maybe<PriceGraphDetail>;
  priceTransparency: PriceTransparency;
  promotionTextBanner: PromotionTextBanner;
  promotions: Array<Promotion>;
  receiveAds?: Maybe<TravelReceiveAd>;
  recommend: Recommend;
  recommendByCity: Array<LatestFareBySchedule>;
  recommendByTheme: Array<MinFareByTheme>;
  regularBanner: Array<RegularBanner>;
  scheduledList: Array<EverywhereFlight>;
  searchHistories: Array<SearchHistory>;
  statsRecommendedHotels: StatsRecommendedHotels;
  travelUser: TravelUser;
  unpaidPaypoints?: Maybe<Scalars['String']['output']>;
  visibleThemes: Array<Theme>;
};


export type QueryAirportAutocompleteArgs = {
  airportOnly?: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QueryAirportDetailListArgs = {
  airportCodes: Array<Scalars['String']['input']>;
};


export type QueryBookingOptionsArgs = {
  input: GetBookingOptionsInput;
};


export type QueryBookingRankingsArgs = {
  route: Scalars['String']['input'];
};


export type QueryBookingsArgs = {
  first: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  skip: Scalars['Float']['input'];
  sort: BookingSortOrderInput;
};


export type QueryCountryArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryCouponsArgs = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  usable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDomesticDailyPriceListArgs = {
  param: GetDomesticFaresInput;
};


export type QueryExtraContentArgs = {
  airline: Scalars['String']['input'];
  arrival: Scalars['String']['input'];
  departure: Scalars['String']['input'];
  searchDate: Scalars['String']['input'];
  seatGrade: Scalars['String']['input'];
  segs: Array<SegmentInput>;
};


export type QueryFavoriteArgs = {
  flightData: FavoriteFlightDataInput;
};


export type QueryFavoritesArgs = {
  isActive: Scalars['Boolean']['input'];
  sort: FavoriteSortOrderInput;
};


export type QueryFlightFareArgs = {
  agent: Scalars['Int']['input'];
  departDate: Scalars['String']['input'];
  from: Array<Scalars['String']['input']>;
  hoursBefore: Scalars['Int']['input'];
  mode: Scalars['String']['input'];
  returnDate?: InputMaybe<Scalars['String']['input']>;
  roundTripTime?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['String']['input'];
};


export type QueryHolidaysArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryImpRankingsArgs = {
  route: Scalars['String']['input'];
};


export type QueryOtaInfoArgs = {
  otaId: Scalars['ID']['input'];
};


export type QueryPriceChangesSubscriptionArgs = {
  searchKey: Scalars['String']['input'];
};


export type QueryPriceGraphArgs = {
  includeEventFare: Scalars['Boolean']['input'];
  nonstop: Scalars['Boolean']['input'];
  period: Scalars['Int']['input'];
  searchKey: Scalars['String']['input'];
};


export type QueryPriceGraphDetailArgs = {
  cabinClass: CabinClass;
  includeEventFare: Scalars['Boolean']['input'];
  itineraryId: Scalars['String']['input'];
  period: Scalars['Int']['input'];
};


export type QueryPriceTransparencyArgs = {
  otaId: Scalars['String']['input'];
  priceTransparencyUrl: Scalars['String']['input'];
};


export type QueryPromotionTextBannerArgs = {
  fareType?: InputMaybe<CabinClass>;
  itinerary: Array<ItineraryInput>;
  route: SearchType;
  trip?: InputMaybe<TripType>;
};


export type QueryPromotionsArgs = {
  fareType?: InputMaybe<CabinClass>;
  route: SearchType;
  trip?: InputMaybe<TripType>;
};


export type QueryRecommendArgs = {
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  includesWeekendOnly?: Scalars['Boolean']['input'];
  internationalOnly?: Scalars['Boolean']['input'];
  recommendOnly?: Scalars['Boolean']['input'];
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  scity?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendByCityArgs = {
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  includesWeekendOnly?: Scalars['Boolean']['input'];
  internationalOnly?: Scalars['Boolean']['input'];
  recommendOnly?: Scalars['Boolean']['input'];
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  scity?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendByThemeArgs = {
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  includesWeekendOnly?: Scalars['Boolean']['input'];
  internationalOnly?: Scalars['Boolean']['input'];
  recommendOnly?: Scalars['Boolean']['input'];
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  scity?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegularBannerArgs = {
  bannerType: BannerType;
  domain?: InputMaybe<BannerDomainType>;
  isNx: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  position: BannerPosition;
  shuffle: Scalars['Boolean']['input'];
  targeting?: InputMaybe<BannerTargetingType>;
};


export type QueryScheduledListArgs = {
  arrivalDate: Scalars['String']['input'];
  departureCityCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
};


export type QuerySearchHistoriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatsRecommendedHotelsArgs = {
  adultCnt?: InputMaybe<Scalars['Int']['input']>;
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  childCnt?: InputMaybe<Scalars['Int']['input']>;
  iataCode: Scalars['String']['input'];
  impSection: HotelImpSection;
  includeTax?: InputMaybe<Scalars['Boolean']['input']>;
  recoType: HotelRecoType;
};

export type Recommend = {
  __typename?: 'Recommend';
  count: Scalars['Float']['output'];
  list: Array<RecommendFlight>;
  minFare: Scalars['Float']['output'];
};

export type RecommendFlight = {
  __typename?: 'RecommendFlight';
  arrivalCity: Location;
  cityImage?: Maybe<Scalars['String']['output']>;
  departureCity: Location;
  duration: Scalars['Float']['output'];
  fare: Scalars['Float']['output'];
  isDomestic: Scalars['Boolean']['output'];
  roundTripTime: Scalars['Float']['output'];
  sdate1: Scalars['String']['output'];
  sdate2: Scalars['String']['output'];
  stops: Scalars['Float']['output'];
};

export type RefundPolicy = {
  __typename?: 'RefundPolicy';
  isFreeSameDayRefundable: Scalars['Boolean']['output'];
  otaCancellationFee?: Maybe<Scalars['Int']['output']>;
  otaCommissionFee?: Maybe<Scalars['Int']['output']>;
  otaCommissionRefundable: Scalars['Boolean']['output'];
  refundPolicyUrl?: Maybe<Scalars['String']['output']>;
  refundableDuringWeekend: Scalars['Boolean']['output'];
  refundableTime?: Maybe<Scalars['String']['output']>;
};

export type RefundPolicyBySearchType = {
  __typename?: 'RefundPolicyBySearchType';
  domestic?: Maybe<RefundPolicy>;
  international?: Maybe<RefundPolicy>;
};

export type RegularBanner = {
  __typename?: 'RegularBanner';
  backgroundColor: Scalars['String']['output'];
  contentMo?: Maybe<Scalars['String']['output']>;
  contentPc?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  headingColor?: Maybe<Scalars['String']['output']>;
  imageUrlMo?: Maybe<Scalars['String']['output']>;
  imageUrlPc?: Maybe<Scalars['String']['output']>;
  isAdMark: Scalars['Boolean']['output'];
  isNx: Scalars['Boolean']['output'];
  landingUrlMo?: Maybe<Scalars['String']['output']>;
  landingUrlPc: Scalars['String']['output'];
  logCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SearchHistory = {
  __typename?: 'SearchHistory';
  fareType: Scalars['String']['output'];
  historyId: Scalars['String']['output'];
  isDirect: Scalars['Boolean']['output'];
  passenger: Passenger;
  searchType: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  trip: Scalars['String']['output'];
  tripList: Array<SearchHistoryTrip>;
};

export type SearchHistoryInput = {
  fareType: Scalars['String']['input'];
  isDirect: Scalars['Boolean']['input'];
  passenger: PassengerInput;
  searchType: Scalars['String']['input'];
  trip: Scalars['String']['input'];
  tripList: Array<SearchHistoryTripInput>;
};

export type SearchHistoryTrip = {
  __typename?: 'SearchHistoryTrip';
  departureCityCode: Scalars['String']['output'];
  departureCityName: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  destinationCityCode: Scalars['String']['output'];
  destinationCityName: Scalars['String']['output'];
  isDomesticDeparture: Scalars['Boolean']['output'];
  isDomesticDestination: Scalars['Boolean']['output'];
};

export type SearchHistoryTripInput = {
  departureCityCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  destinationCityCode: Scalars['String']['input'];
};

export type SearchLocation = {
  __typename?: 'SearchLocation';
  airportName?: Maybe<Scalars['String']['output']>;
  airportNameEn?: Maybe<Scalars['String']['output']>;
  cityCode?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  cityNameEn?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  countryNameEn: Scalars['String']['output'];
  event?: Maybe<Scalars['Boolean']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  isDomestic?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export type SearchParamsInput = {
  fareType: CabinClass;
  itinerary: Array<ItineraryInput>;
  person: PassengerInput;
  trip: TripType;
};

export enum SearchType {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export type SegmentInput = {
  airV: Scalars['String']['input'];
  arr: Scalars['String']['input'];
  bookingClass: Scalars['String']['input'];
  dep: Scalars['String']['input'];
  equipment: Scalars['String']['input'];
  fltNum: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type SelectedDomesticFlightInput = {
  airlineCode: Scalars['String']['input'];
  arrCity: Scalars['String']['input'];
  arrivalDate: Scalars['String']['input'];
  depCity: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  minFare: Scalars['Float']['input'];
};

export type ServiceActive = {
  __typename?: 'ServiceActive';
  ad: Scalars['Boolean']['output'];
  mypage: Scalars['Boolean']['output'];
  realtime: Scalars['Boolean']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatsRecommendedHotels = {
  __typename?: 'StatsRecommendedHotels';
  age: Scalars['Float']['output'];
  gender: Scalars['String']['output'];
  hotelsInfo: Array<HotelInfo>;
  impLogUrl: Scalars['String']['output'];
  recoType: Scalars['String']['output'];
};

export type TaAward = {
  __typename?: 'TaAward';
  type: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type Theme = {
  __typename?: 'Theme';
  order: Scalars['Float']['output'];
  theme_id: Scalars['Float']['output'];
  theme_image: Scalars['String']['output'];
  theme_name: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type TravelClubPaypoint = {
  __typename?: 'TravelClubPaypoint';
  agtCode: Scalars['String']['output'];
  bookingId: Scalars['String']['output'];
  isPaid: Scalars['Boolean']['output'];
  savingAmount: Scalars['Float']['output'];
  savingPossibleDate: Scalars['DateTime']['output'];
};

export type TravelCoupon = {
  __typename?: 'TravelCoupon';
  createdBookingId: Scalars['String']['output'];
  createdDate: Scalars['Float']['output'];
  createdPartnerId: Scalars['String']['output'];
  createdService: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  endDate: Scalars['Float']['output'];
  exposeMeta: ExposeMeta;
  isUsed: Scalars['Boolean']['output'];
  nidNo: Scalars['String']['output'];
  seq?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['Float']['output'];
  templateId: Scalars['String']['output'];
  usedService: Scalars['String']['output'];
};

export type TravelReceiveAd = {
  __typename?: 'TravelReceiveAd';
  isAssent: Scalars['Boolean']['output'];
  nidNo: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type TravelUser = {
  __typename?: 'TravelUser';
  travelClub: Travelclub;
};

export type Travelclub = {
  __typename?: 'Travelclub';
  benefits: Array<TravelclubBenefit>;
  grade: Scalars['Float']['output'];
};

export type TravelclubBenefit = {
  __typename?: 'TravelclubBenefit';
  agtCode: Scalars['String']['output'];
  bizType: Scalars['String']['output'];
  bookingEndDate: Scalars['DateTime']['output'];
  bookingStartDate: Scalars['DateTime']['output'];
  countryCodes?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  locType?: Maybe<Scalars['String']['output']>;
  minimumOrderAmount: Scalars['Float']['output'];
  savings: Array<TravelclubSaving>;
  usingEndDate?: Maybe<Scalars['DateTime']['output']>;
  usingStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TravelclubSaving = {
  __typename?: 'TravelclubSaving';
  grade: Scalars['Float']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  rate: Scalars['Float']['output'];
};

export enum TripType {
  Md = 'MD',
  Ow = 'OW',
  Rt = 'RT'
}

export type UpdateFavoriteFlightPriceResult = {
  __typename?: 'UpdateFavoriteFlightPriceResult';
  allFareTypes?: Maybe<Array<MinFareByType>>;
  fare: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UpdatePriceChangesSubscriptionInput = {
  changes: Array<Scalars['Int']['input']>;
  minPrice: Scalars['Float']['input'];
  searchKey: Scalars['String']['input'];
};

export type UpdateReceiveAdsResponse = {
  __typename?: 'UpdateReceiveAdsResponse';
  isAssent: Scalars['Boolean']['output'];
  nidNo: Scalars['String']['output'];
  notifyStatus: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type UpdateTravelPersonalInfoAgreementResponse = {
  __typename?: 'UpdateTravelPersonalInfoAgreementResponse';
  isSuccess: Scalars['Boolean']['output'];
};

export type AirportAutocompleteQueryVariables = Exact<{
  airportOnly: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
}>;


export type AirportAutocompleteQuery = { __typename?: 'Query', airportAutocomplete: Array<{ __typename?: 'SearchLocation', type: string, iataCode?: string | null, airportName?: string | null, airportNameEn?: string | null, cityCode?: string | null, cityName?: string | null, cityNameEn?: string | null, countryCode: string, countryName: string, countryNameEn: string, event?: boolean | null, isDomestic?: boolean | null }> };

export type Flight_Recommend_Min_FareQueryVariables = Exact<{
  scity?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
  recommendOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Flight_Recommend_Min_FareQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', minFare: number } };

export type DomesticDailyPriceListQueryVariables = Exact<{
  param: GetDomesticFaresInput;
}>;


export type DomesticDailyPriceListQuery = { __typename?: 'Query', domesticDailyPriceList: Array<{ __typename?: 'DailyDomesticFare', date: string, price: number }> };

export type FlightFareQueryVariables = Exact<{
  from: Array<Scalars['String']['input']> | Scalars['String']['input'];
  to: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  departDate: Scalars['String']['input'];
  hoursBefore: Scalars['Int']['input'];
  roundTripTime?: InputMaybe<Scalars['Int']['input']>;
  agent: Scalars['Int']['input'];
}>;


export type FlightFareQuery = { __typename?: 'Query', flightFare: Array<{ __typename?: 'FaresByDate', date: string, fares: Array<{ __typename?: 'Fare', stops: number, fare: number }> }> };

export type PriceAlertNightConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type PriceAlertNightConsentQuery = { __typename?: 'Query', priceAlertNightConsent?: { __typename?: 'PriceAlertNightConsent', isConsented: boolean, updatedAt?: any | null } | null };

export type UpdatePriceAlertNightConsentMutationVariables = Exact<{
  isConsented: Scalars['Boolean']['input'];
}>;


export type UpdatePriceAlertNightConsentMutation = { __typename?: 'Mutation', updatePriceAlertNightConsent: { __typename?: 'PriceAlertNightConsent', isConsented: boolean, updatedAt?: any | null } };

export type Flight_Recommend_By_CityQueryVariables = Exact<{
  scity?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  continents?: InputMaybe<Scalars['String']['input']>;
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
}>;


export type Flight_Recommend_By_CityQuery = { __typename?: 'Query', recommendByCity: Array<{ __typename?: 'LatestFareBySchedule', airline: string, sdate1: string, sdate2: string, price: number, stops: number, roundTripTime: number }> };

export type RegularBannerQueryVariables = Exact<{
  bannerType: BannerType;
  isNx: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  position: BannerPosition;
  shuffle?: Scalars['Boolean']['input'];
  domain?: InputMaybe<BannerDomainType>;
  targeting?: InputMaybe<BannerTargetingType>;
}>;


export type RegularBannerQuery = { __typename?: 'Query', regularBanner: Array<{ __typename?: 'RegularBanner', heading?: string | null, headingColor?: string | null, backgroundColor: string, contentPc?: string | null, contentMo?: string | null, imageUrlPc?: string | null, imageUrlMo?: string | null, landingUrlPc: string, landingUrlMo?: string | null, isAdMark: boolean, logCode: string }> };

export type BookingPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingPartnersQuery = { __typename?: 'Query', bookingPartners: Array<{ __typename?: 'Ota', otaId: string, expName: string }> };

export type MaskedIdQueryVariables = Exact<{ [key: string]: never; }>;


export type MaskedIdQuery = { __typename?: 'Query', maskedId: string };

export type GetOtaListQueryVariables = Exact<{
  curations: Array<Scalars['String']['input']> | Scalars['String']['input'];
  device: DeviceType;
  otaFares: Array<OtaFareInput> | OtaFareInput;
  scheduleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  searchParams: SearchParamsInput;
}>;


export type GetOtaListQuery = { __typename?: 'Query', bookingOptions: { __typename?: 'BookingOptions', otaList: Array<{ __typename?: 'BookingOption', bookingUrl: string, otaId: string, expName: string, fare: number, fareType: string, supportNPay?: boolean | null, supportNaverLogin: boolean, otaType?: OtaType | null, isCsCenter?: boolean | null, isCsCenterEmail?: boolean | null, isKoreanWebsite?: boolean | null, agreeStatus: string, caution?: string | null, adText?: string | null, csInfo?: { __typename?: 'CsInfo', active?: boolean | null, phone1?: string | null, phone2?: string | null, businessHour?: string | null, lunchTime?: string | null, is365Days?: boolean | null, email?: string | null, online?: string | null, otherContactInfo?: string | null } | null, active: { __typename?: 'ServiceActive', mypage: boolean, realtime: boolean, ad: boolean }, refundPolicy?: { __typename?: 'RefundPolicy', isFreeSameDayRefundable: boolean } | null }> } };

export type GetPriceTransparencyQueryVariables = Exact<{
  otaId: Scalars['String']['input'];
  priceTransparencyUrl: Scalars['String']['input'];
}>;


export type GetPriceTransparencyQuery = { __typename?: 'Query', priceTransparency: { __typename?: 'PriceTransparency', tag: { __typename?: 'PriceTransparencyTag', isMileageAvailable?: boolean | null, isSeatSelectionAvailable?: boolean | null, cancel?: { __typename?: 'PriceTransparencyTagCancel', available: boolean, cancelFeePeriod?: any | null, isFeeNeeded: boolean, identified: boolean } | null, change?: { __typename?: 'PriceTransparencyTagChange', available: boolean, changeFeePeriod?: any | null, isFeeNeeded: boolean, identified: boolean } | null, checked?: { __typename?: 'PriceTransparencyChecked', available: boolean, identified: boolean, weight?: number | null, quantity?: number | null } | null, cabin?: { __typename?: 'PriceTransparencyCabin', available: boolean, identified: boolean, weight?: number | null, quantity?: number | null } | null }, detail: Array<{ __typename?: 'PriceTransparencyDetail', id: string, otaId: string, policy: { __typename?: 'PriceTransparencyPolicy', baggage?: { __typename?: 'PriceTransparencyBaggage', available: boolean, conditions?: Array<{ __typename?: 'PriceTransparencyBaggageCondition', unit?: string | null, quantity?: number | null, weight?: number | null, type: string }> | null } | null, cancel?: { __typename?: 'PriceTransparencyCancel', available: boolean, conditions?: Array<{ __typename?: 'PriceTransparencyCancelCondition', period: number, fee: number, currency: string, type: string }> | null } | null, change?: { __typename?: 'PriceTransparencyChange', available: boolean, conditions?: Array<{ __typename?: 'PriceTransparencyChangeCondition', type: string, period: number, currency: string, fee: number }> | null } | null, mileage?: { __typename?: 'PriceTransparencyMileage', available: boolean, amount?: number | null, rate?: number | null } | null, additionalServices?: { __typename?: 'PriceTransparencyAdditionalServices', seatSelectionAvailable?: boolean | null, mealIncluded?: boolean | null } | null } }> } };

export type ScheduledListQueryVariables = Exact<{
  departureCityCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  arrivalDate: Scalars['String']['input'];
}>;


export type ScheduledListQuery = { __typename?: 'Query', scheduledList: Array<{ __typename?: 'EverywhereFlight', isOversea: boolean, totalFare: number, stops?: number | null, duration: number, departure: { __typename?: 'EverywhereFlightTrip', cityCode: string, cityName: string, airlineCode: string, airlineName: string, fare?: number | null, location: { __typename?: 'Coordinate', latitude: number, longitude: number } }, destination: { __typename?: 'EverywhereFlightTrip', cityCode: string, cityImage?: string | null, cityName: string, continentId: number, countryCode: string, fare?: number | null, rank: number, themeIds: Array<number>, location: { __typename?: 'Coordinate', latitude: number, longitude: number } } }> };

export type Flight_RecommendQueryVariables = Exact<{
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  scity?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  internationalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recommendOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
}>;


export type Flight_RecommendQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', list: Array<{ __typename?: 'RecommendFlight', stops: number, duration: number, fare: number, isDomestic: boolean, sdate1: string, sdate2: string, cityImage?: string | null, roundTripTime: number, departureCity: { __typename?: 'Location', iataCode: string, cityName?: string | null, popularity?: number | null, location?: { __typename?: 'Coordinate', latitude: number, longitude: number } | null }, arrivalCity: { __typename?: 'Location', iataCode: string, cityName?: string | null, popularity?: number | null, location?: { __typename?: 'Coordinate', latitude: number, longitude: number } | null } }> } };

export type Flight_Recommend_By_Theme_EverywhereQueryVariables = Exact<{
  scity?: InputMaybe<Scalars['String']['input']>;
  recommendOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Flight_Recommend_By_Theme_EverywhereQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', minFare: number }, recommendByTheme: Array<{ __typename?: 'MinFareByTheme', themeId: number, themeName: string, themeImage: string, fare: number }> };

export type Flight_Recommend_CountQueryVariables = Exact<{
  continents?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  scity?: InputMaybe<Scalars['String']['input']>;
  ecity?: InputMaybe<Scalars['String']['input']>;
  fare?: InputMaybe<Scalars['String']['input']>;
  recommendOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roundTripTime?: InputMaybe<Scalars['String']['input']>;
  sdate?: InputMaybe<Scalars['String']['input']>;
  stops?: InputMaybe<Scalars['Int']['input']>;
  themes?: InputMaybe<Scalars['String']['input']>;
}>;


export type Flight_Recommend_CountQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', count: number } };

export type UpdateNlabelAgreementsMutationVariables = Exact<{
  isAgreed: Scalars['Boolean']['input'];
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNlabelAgreementsMutation = { __typename?: 'Mutation', updateNlabelAgreements: { __typename?: 'UpdateTravelPersonalInfoAgreementResponse', isSuccess: boolean } };

export type Get_Promotion_BannerQueryVariables = Exact<{
  fareType?: InputMaybe<CabinClass>;
  itinerary: Array<ItineraryInput> | ItineraryInput;
  route: SearchType;
  trip?: InputMaybe<TripType>;
}>;


export type Get_Promotion_BannerQuery = { __typename?: 'Query', promotionTextBanner: { __typename?: 'PromotionTextBanner', discount?: { __typename?: 'PromotionBenefit', unit: string, value: number, limit?: number | null } | null, payPoint?: { __typename?: 'PromotionBenefit', unit: string, value: number, limit?: number | null } | null } };

export type CountryQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type CountryQuery = { __typename?: 'Query', country?: { __typename?: 'Country', countryName: string } | null };

export type StatsRecommendedHotelsQueryVariables = Exact<{
  checkIn: Scalars['String']['input'];
  checkOut: Scalars['String']['input'];
  iataCode: Scalars['String']['input'];
  impSection: HotelImpSection;
  recoType: HotelRecoType;
  adultCnt?: InputMaybe<Scalars['Int']['input']>;
  childCnt?: InputMaybe<Scalars['Int']['input']>;
  includeTax?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StatsRecommendedHotelsQuery = { __typename?: 'Query', statsRecommendedHotels: { __typename?: 'StatsRecommendedHotels', impLogUrl: string, hotelsInfo: Array<{ __typename?: 'HotelInfo', clkLogUrl: string, id: string, image: string, name: string, overallRating: number, price: number }> } };

export type LogSelectedFlightsMutationVariables = Exact<{
  flights: Array<SelectedDomesticFlightInput> | SelectedDomesticFlightInput;
}>;


export type LogSelectedFlightsMutation = { __typename?: 'Mutation', logSelectedFlights: boolean };

export type BookingOptionsQueryVariables = Exact<{
  combinedFares?: InputMaybe<Array<OtaFareInput> | OtaFareInput>;
  device: DeviceType;
  otaFares: Array<OtaFareInput> | OtaFareInput;
  scheduleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  searchParams: SearchParamsInput;
}>;


export type BookingOptionsQuery = { __typename?: 'Query', bookingOptions: { __typename?: 'BookingOptions', combined: Array<{ __typename?: 'BookingOption', otaId: string, expName: string, fare: number, bookingUrl: string, supportNPay?: boolean | null, supportNaverLogin: boolean, otaType?: OtaType | null, isCsCenter?: boolean | null, isCsCenterEmail?: boolean | null, agreeStatus: string, isKoreanWebsite?: boolean | null, caution?: string | null, adText?: string | null, csInfo?: { __typename?: 'CsInfo', active?: boolean | null, phone1?: string | null, phone2?: string | null, businessHour?: string | null, lunchTime?: string | null, is365Days?: boolean | null, email?: string | null, online?: string | null, otherContactInfo?: string | null } | null, active: { __typename?: 'ServiceActive', mypage: boolean, realtime: boolean, ad: boolean }, refundPolicy?: { __typename?: 'RefundPolicy', isFreeSameDayRefundable: boolean } | null }>, otaList: Array<{ __typename?: 'BookingOption', otaId: string, expName: string, fare: number, bookingUrl: string, supportNPay?: boolean | null, supportNaverLogin: boolean, otaType?: OtaType | null, isCsCenter?: boolean | null, isCsCenterEmail?: boolean | null, agreeStatus: string, isKoreanWebsite?: boolean | null, caution?: string | null, adText?: string | null, csInfo?: { __typename?: 'CsInfo', active?: boolean | null, phone1?: string | null, phone2?: string | null, businessHour?: string | null, lunchTime?: string | null, is365Days?: boolean | null, email?: string | null, online?: string | null, otherContactInfo?: string | null } | null, active: { __typename?: 'ServiceActive', mypage: boolean, realtime: boolean, ad: boolean }, refundPolicy?: { __typename?: 'RefundPolicy', isFreeSameDayRefundable: boolean } | null }> } };

export type PromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromotionsQuery = { __typename?: 'Query', promotions: Array<{ __typename?: 'Promotion', departureStartDate?: any | null, departureEndDate?: any | null, otas?: Array<string> | null, airlines?: Array<string> | null, originAirports?: Array<string> | null, destinationAirports?: Array<string> | null, description?: string | null, paymentMethods?: Array<{ __typename?: 'CodeName', code: string, name: string }> | null, passengers: { __typename?: 'ActivePassenger', adult: boolean, child: boolean, infant: boolean }, benefit: { __typename?: 'PromotionBenefit', unit: string, value: number, limit?: number | null } }> };

export type Flight_Recommend_By_ThemeQueryVariables = Exact<{
  recommendOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Flight_Recommend_By_ThemeQuery = { __typename?: 'Query', recommendByTheme: Array<{ __typename?: 'MinFareByTheme', themeId: number, themeName: string, themeImage: string, fare: number, departureDate: string }> };

export type AddBookingMutationVariables = Exact<{
  otaId: Scalars['String']['input'];
  agtBookingKey: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
}>;


export type AddBookingMutation = { __typename?: 'Mutation', addBooking: AddBookingStatus };

export type BookingAgreementQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingAgreementQuery = { __typename?: 'Query', bookingAgreement?: string | null };

export type SaveBookingAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type SaveBookingAgreementMutation = { __typename?: 'Mutation', saveBookingAgreement: string };

export type DeleteAllInactiveBookingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllInactiveBookingsMutation = { __typename?: 'Mutation', deleteAllInactiveBookings: boolean };

export type AccumulatePromotionPaypointMutationVariables = Exact<{
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
}>;


export type AccumulatePromotionPaypointMutation = { __typename?: 'Mutation', accumulatePromotionPaypoint: { __typename?: 'AccumulatePromotionPaypointResult', isSuccess: boolean, message: string, paypoint?: { __typename?: 'PromotionPaypoint', agtCode: string, bookingKey: string, isPaid: boolean, savingAmount: number } | null } };

export type AccumulateTravelclubPaypointMutationVariables = Exact<{
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
}>;


export type AccumulateTravelclubPaypointMutation = { __typename?: 'Mutation', accumulateTravelclubPaypoint: { __typename?: 'AccumulateTravelClubPaypointResult', isSuccess: boolean, message: string, paypoint?: { __typename?: 'TravelClubPaypoint', agtCode: string, bookingId: string, isPaid: boolean, savingAmount: number } | null } };

export type DeleteBookingMutationVariables = Exact<{
  bookingKey: Scalars['String']['input'];
  otaId: Scalars['String']['input'];
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', deleteBooking?: { __typename?: 'Booking', bookingKey: string, otaId: string, deleted: boolean } | null };

export type TravelClubGradeQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelClubGradeQuery = { __typename?: 'Query', nickname: string, travelUser: { __typename?: 'TravelUser', travelClub: { __typename?: 'Travelclub', grade: number } } };

export type DeleteFavoritesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteFavoritesMutation = { __typename?: 'Mutation', deleteFavorites: Array<{ __typename?: 'Favorite', id: string, flightId: string, isDeleted?: boolean | null }> };

export type UpdateFavoriteFlightPriceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UpdateFavoriteFlightPriceMutation = { __typename?: 'Mutation', updateFavoriteFlightPrice: { __typename?: 'UpdateFavoriteFlightPriceResult', fare: number, updatedAt: any, allFareTypes?: Array<{ __typename?: 'MinFareByType', code: string, name: string, fare: number }> | null } };

export type FavoritesQueryVariables = Exact<{
  isActive: Scalars['Boolean']['input'];
  sort: FavoriteSortOrderInput;
}>;


export type FavoritesQuery = { __typename?: 'Query', favorites: { __typename?: 'FavoriteConnection', totalCount: number, edges?: Array<{ __typename?: 'FavoriteEdge', node: { __typename?: 'Favorite', id: string, bookingUrl: string, cabinClass: string, destinationImageUrl: string, fare?: number | null, fareTypeName?: string | null, flightId: string, groupId: string, isDeleted?: boolean | null, tripType: string, updatedAt: any, itineraries: Array<{ __typename?: 'FavoriteItinerary', departureLocationCode: string, departureCityName: string, arrivalLocationCode: string, arrivalCityName: string, departureDate: string }>, passengers: { __typename?: 'Passenger', adult: number, child: number, infant: number }, schedules: Array<{ __typename?: 'FavoriteSchedule', airlineCode: string, airlineName: string, departureAirportCode: string, arrivalAirportCode: string, departureDate: string, arrivalDate: string, duration: number, stops: number }> } }> | null } };

export type OtaInfoQueryVariables = Exact<{
  device: DeviceType;
  otaId: Scalars['ID']['input'];
  searchType: SearchType;
}>;


export type OtaInfoQuery = { __typename?: 'Query', otaInfo: { __typename?: 'Ota', otaType?: OtaType | null, isCsCenter?: boolean | null, isCsCenterEmail?: boolean | null, isKoreanWebsite?: boolean | null, active: { __typename?: 'ServiceActive', mypage: boolean }, refundPolicy?: { __typename?: 'RefundPolicy', otaCancellationFee?: number | null, otaCommissionFee?: number | null, otaCommissionRefundable: boolean, refundableTime?: string | null } | null } };

export type AddFavoriteMutationVariables = Exact<{
  flightData: FavoriteFlightDataInput;
  groupParam: FavoriteSearchParamsInput;
}>;


export type AddFavoriteMutation = { __typename?: 'Mutation', addFavoriteV2: { __typename?: 'Favorite', id: string, flightId: string, isDeleted?: boolean | null } };

export type AirportDetailListQueryVariables = Exact<{
  airportCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AirportDetailListQuery = { __typename?: 'Query', airportDetailList: Array<{ __typename?: 'Location', iataCode: string, cityName?: string | null, isDomestic: boolean, event: boolean, airportName?: string | null, countryName?: string | null, cityImage?: { __typename?: 'CityImage', imagePath?: string | null, copyright?: string | null, copyrightUrl?: string | null } | null }> };

export type BookingsQueryVariables = Exact<{
  isActive: Scalars['Boolean']['input'];
  first: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
  sort: BookingSortOrderInput;
}>;


export type BookingsQuery = { __typename?: 'Query', bookings: { __typename?: 'BookingConnection', totalCount: number, edges?: Array<{ __typename?: 'BookingClassEdge', node: { __typename?: 'Booking', bookingKey: string, agtBookingKey: string, bookingDate: any, bookingStatus: string, confirmTotalFare: number, deleted: boolean, destinationImageUrl: string, landingUrlMo: string, landingUrlPc: string, otaId: string, payDate?: any | null, pnrNo?: string | null, seatClass: string, tktDate?: any | null, tripType: string, itinerary: Array<{ __typename?: 'BookingItinerary', airlineCode: string, airlineName: string, departureAirportCode: string, departureCityName: string, departureDate?: string | null, arrivalAirportCode: string, arrivalCityName: string, arrivalDate?: string | null, journeyTime?: number | null, operatingCarrierName?: string | null, stops?: number | null }>, otaInfo: { __typename?: 'Ota', caution?: string | null, expName: string, isCsCenter?: boolean | null, isCsCenterEmail?: boolean | null, isKoreanWebsite?: boolean | null, otaType?: OtaType | null, csInfo?: { __typename?: 'CsInfo', active?: boolean | null, businessHour?: string | null, email?: string | null, is365Days?: boolean | null, lunchTime?: string | null, online?: string | null, otherContactInfo?: string | null, phone1?: string | null, phone2?: string | null } | null }, passengers: { __typename?: 'Passenger', adult: number, child: number, infant: number }, promotionPaypoint?: { __typename?: 'PromotionPaypoint', agtCode: string, bookingKey: string, isPaid: boolean, savingAmount: number, savingPossibleDate: any } | null, travelClubPaypoint?: { __typename?: 'TravelClubPaypoint', agtCode: string, bookingId: string, isPaid: boolean, savingAmount: number, savingPossibleDate: any } | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type CreatePriceChangesSubscriptionMutationVariables = Exact<{
  subscription: CreatePriceChangesSubscriptionInput;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePriceChangesSubscriptionMutation = { __typename?: 'Mutation', createPriceChangesSubscription?: { __typename?: 'PriceChangesSubscription', searchKey: string, adultCount: number, childCount: number, infantCount: number, cabinClass: CabinClass, isNonstop: boolean, tripType: TripType, changes: any, createdAt: any, isDeleted?: boolean | null, originalMinPrice: number, updatedMinPrice?: number | null, itineraries: Array<{ __typename?: 'ItineraryClass', departureLocationCode: string, departureLocationName: string, arrivalLocationCode: string, arrivalLocationName: string, departureDate: string }> } | null };

export type CurationQueryVariables = Exact<{
  route: Scalars['String']['input'];
}>;


export type CurationQuery = { __typename?: 'Query', bookingRankings: Array<{ __typename?: 'BookingRanking', flightNumbers: string }>, impRankings: Array<{ __typename?: 'ImpRanking', flightNumbers: string }> };

export type DeletePriceChangesSubscriptionMutationVariables = Exact<{
  searchKey: Scalars['String']['input'];
}>;


export type DeletePriceChangesSubscriptionMutation = { __typename?: 'Mutation', deletePriceChangesSubscription?: { __typename?: 'PriceChangesSubscription', searchKey: string, isDeleted?: boolean | null } | null };

export type DeleteFavoriteMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteFavoriteMutation = { __typename?: 'Mutation', deleteFavorites: Array<{ __typename?: 'Favorite', id: string, flightId: string, isDeleted?: boolean | null }> };

export type GetExtraContentQueryVariables = Exact<{
  airline: Scalars['String']['input'];
  departure: Scalars['String']['input'];
  arrival: Scalars['String']['input'];
  searchDate: Scalars['String']['input'];
  seatGrade: Scalars['String']['input'];
  segs: Array<SegmentInput> | SegmentInput;
}>;


export type GetExtraContentQuery = { __typename?: 'Query', extraContent: Array<{ __typename?: 'Amenity', equipmentDesc: string, inFlightEntertainment?: AmenityAvailability | null, mealsAndBeverages?: AmenityAvailability | null, seatArrangement: string, seatInfo: string, usb?: AmenityAvailability | null, wiFi?: AmenityAvailability | null, inFlightMealImages: Array<{ __typename?: 'ImageFile', imageFileName: string }>, insideImages: Array<{ __typename?: 'ImageFile', imageFileName: string }>, outsideImages: Array<{ __typename?: 'ImageFile', imageFileName: string }> }> };

export type FlightsCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FlightsCardsQuery = { __typename?: 'Query', flightsCards: Array<{ __typename?: 'FareType', code: string, name: string, category?: string | null, naverPaySaving?: number | null }> };

export type GetFavoriteQueryVariables = Exact<{
  flightData: FavoriteFlightDataInput;
}>;


export type GetFavoriteQuery = { __typename?: 'Query', favorite: { __typename?: 'Favorite', id: string, flightId: string, isDeleted?: boolean | null } };

export type AddHistoryMutationVariables = Exact<{
  history: SearchHistoryInput;
}>;


export type AddHistoryMutation = { __typename?: 'Mutation', addHistory?: { __typename?: 'SearchHistory', historyId: string } | null };

export type DeleteHistoryMutationVariables = Exact<{
  hashKey: Scalars['String']['input'];
}>;


export type DeleteHistoryMutation = { __typename?: 'Mutation', deleteHistory: boolean };

export type SearchHistoriesQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchHistoriesQuery = { __typename?: 'Query', searchHistories: Array<{ __typename?: 'SearchHistory', historyId: string, timestamp: number, trip: string, fareType: string, searchType: string, isDirect: boolean, passenger: { __typename?: 'Passenger', adult: number, child: number, infant: number }, tripList: Array<{ __typename?: 'SearchHistoryTrip', departureDate: string, departureCityCode: string, departureCityName: string, isDomesticDeparture: boolean, destinationCityCode: string, destinationCityName: string, isDomesticDestination: boolean }> }> };

export type HolidaysQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type HolidaysQuery = { __typename?: 'Query', holidays: Array<{ __typename?: 'Holiday', name: string, date: string, type: HolidayType }> };

export type International_PromotionsQueryVariables = Exact<{
  fareType: CabinClass;
  trip: TripType;
}>;


export type International_PromotionsQuery = { __typename?: 'Query', promotions: Array<{ __typename?: 'Promotion', departureStartDate?: any | null, departureEndDate?: any | null, otas?: Array<string> | null, airlines?: Array<string> | null, originAirports?: Array<string> | null, destinationAirports?: Array<string> | null, nonstopOnly: boolean, description?: string | null, fareTypes?: Array<{ __typename?: 'CodeName', code: string, name: string }> | null, paymentMethods?: Array<{ __typename?: 'CodeName', code: string, name: string }> | null, passengers: { __typename?: 'ActivePassenger', adult: boolean, child: boolean, infant: boolean }, benefit: { __typename?: 'PromotionBenefit', unit: string, value: number, limit?: number | null } }> };

export type PriceChangesSubscriptionQueryVariables = Exact<{
  searchKey: Scalars['String']['input'];
}>;


export type PriceChangesSubscriptionQuery = { __typename?: 'Query', priceChangesSubscription?: { __typename?: 'PriceChangesSubscription', searchKey: string, adultCount: number, childCount: number, infantCount: number, cabinClass: CabinClass, isNonstop: boolean, tripType: TripType, changes: any, createdAt: any, isDeleted?: boolean | null, originalMinPrice: number, updatedMinPrice?: number | null, itineraries: Array<{ __typename?: 'ItineraryClass', departureLocationCode: string, departureLocationName: string, arrivalLocationCode: string, arrivalLocationName: string, departureDate: string }> } | null };

export type PriceChangesSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PriceChangesSubscriptionsQuery = { __typename?: 'Query', priceChangesSubscriptions: { __typename?: 'PriceChangesSubscriptionConnection', totalCount: number, edges?: Array<{ __typename?: 'PriceChangesSubscriptionClassEdge', node: { __typename?: 'PriceChangesSubscription', searchKey: string, adultCount: number, childCount: number, infantCount: number, cabinClass: CabinClass, isNonstop: boolean, tripType: TripType, changes: any, createdAt: any, isDeleted?: boolean | null, originalMinPrice: number, updatedMinPrice?: number | null, itineraries: Array<{ __typename?: 'ItineraryClass', departureLocationCode: string, departureLocationName: string, arrivalLocationCode: string, arrivalLocationName: string, departureDate: string }> } }> | null } };

export type Get_Price_GraphQueryVariables = Exact<{
  searchKey: Scalars['String']['input'];
  includeEventFare: Scalars['Boolean']['input'];
  nonstop: Scalars['Boolean']['input'];
  period: Scalars['Int']['input'];
}>;


export type Get_Price_GraphQuery = { __typename?: 'Query', priceGraph?: { __typename?: 'PriceGraph', averageLowestFare: number, fares: Array<{ __typename?: 'PriceGraphFareBySearchKey', lowestFare?: number | null, searchDate: string }> } | null };

export type Get_Price_Graph_DetailQueryVariables = Exact<{
  itineraryId: Scalars['String']['input'];
  cabinClass: CabinClass;
  includeEventFare: Scalars['Boolean']['input'];
  period: Scalars['Int']['input'];
}>;


export type Get_Price_Graph_DetailQuery = { __typename?: 'Query', priceGraphDetail?: { __typename?: 'PriceGraphDetail', averageLowestFare: number, fares: Array<{ __typename?: 'PriceGraphFareByItineraryId', searchDate: string, lowestFare?: number | null }> } | null };

export type GetReceiveAdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReceiveAdsQuery = { __typename?: 'Query', receiveAds?: { __typename?: 'TravelReceiveAd', isAssent: boolean } | null };

export type VisibleThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type VisibleThemesQuery = { __typename?: 'Query', visibleThemes: Array<{ __typename?: 'Theme', theme_id: number, theme_name: string, visible: boolean, order: number, theme_image: string }> };

export type TravelUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelUserQuery = { __typename?: 'Query', nickname: string, isBiztripUser: boolean, coupons: Array<{ __typename?: 'TravelCoupon', startDate: number, endDate: number }> };

export type Get_Unpaid_PaypointsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Unpaid_PaypointsQuery = { __typename?: 'Query', unpaidPaypoints?: string | null };

export type UpdatePriceChangesSubscriptionMutationVariables = Exact<{
  subscription: UpdatePriceChangesSubscriptionInput;
}>;


export type UpdatePriceChangesSubscriptionMutation = { __typename?: 'Mutation', updatePriceChangesSubscription?: { __typename?: 'PriceChangesSubscription', searchKey: string, changes: any, createdAt: any, originalMinPrice: number, updatedMinPrice?: number | null } | null };

export type ReceiveAdsAssentLinkMutationVariables = Exact<{
  updateAssent: Scalars['Boolean']['input'];
  deviceToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReceiveAdsAssentLinkMutation = { __typename?: 'Mutation', updateReceiveAds: { __typename?: 'UpdateReceiveAdsResponse', isAssent: boolean, nidNo: string, notifyStatus: string, updated: any } };
